<template>
  <div>
    <div class="row section-header">
      <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center mt-4">
        <div class="mt-5 pb-4">
          <h4 class="serif">
            <slot name="title"></slot>
          </h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 offset-3 col-lg-4 offset-lg-4 mb-5">
        <div class="mx-4 border-bottom">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'section-header',
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/rows/SectionHeader.vue